import React from 'react';
import { motion } from 'framer-motion';
import { useAIModule } from '../contexts/AIModuleContext';

const AIConversations: React.FC = () => {
  const { theme } = useAIModule();

  return (
    <div className={`min-h-screen p-6 ${theme === 'dark' ? 'bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900' : 'bg-gray-50'}`}>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="mb-8"
      >
        <h1 className="text-4xl font-bold bg-gradient-to-r from-purple-400 via-pink-400 to-blue-400 bg-clip-text text-transparent">
          AI Conversations
        </h1>
        <p className={`mt-2 ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
          View and manage AI-powered conversations
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className={`rounded-2xl p-8 text-center ${theme === 'dark' ? 'bg-gray-800/80 border border-gray-700/50' : 'bg-white/90 border border-gray-200/50 shadow-lg'}`}
      >
        <h2 className={`text-2xl font-semibold mb-4 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
          AI Conversations
        </h2>
        <p className={theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}>
          Monitor and analyze conversations handled by your AI assistants.
        </p>
      </motion.div>
    </div>
  );
};

export default AIConversations;